import React, { useState } from 'react';
import GuiTypes from '../../models/TactonModel';
import DropdownCustom from '../components/dropdownCustom';
import RadioGroupCustom from '../components/radioGroupCustom';
import ReplayIcon from '@mui/icons-material/Replay';
import ImageCheckBoxCustom from './imageCheckBoxCustom';
import ImageReadOnly from './imageReadOnly';
import { getMembersFromMembers } from '../../services/tactonService';
import TextOptionComponent from '../components/textOptionComponent';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import InfoIcon from '@mui/icons-material/Info';
import AddIcon from '@mui/icons-material/Add';
import CustomTooltip from './customTooltip';

function MemberComponent(props) {
  const {
    member,
    sessionDataItems,
    showGroupHeader,
    handleOnChange,
    startData,
    stepName,
    imageUrls,
    lang
  } = props;

  const [open, setOpen] = useState(true);

  const maxRadio = 10;

  const isHidden = () => {
    if (!member.properties) return false;

    if (member.properties.hidden == 'yes') return true;

    if (member.description == 'Section Position') return true;
    return false;
  };

  const showHeader = () => {
    return isGroup() && hasChildren() && showGroupHeader;
  };

  const isGroup = () => {
    return member.isGroup;
  };

  const hasChildren = () => {
    var children = getMembersFromMembers(member).filter(
      x => !x.isGroup && x.properties.hidden != 'yes'
    );
    return children.length > 0;
  };

  const nameTranslation = () => {
    return member.description;
  };

  const children = () => {
    if (!member.isGroup) return [];

    return member.members;
  };

  const isRadioGroup = () => {
    var guiType = member.properties.guitype;
    return (
      !member.properties.ph_image_field &&
      (guiType == GuiTypes.DropDown || guiType == GuiTypes.Radio) &&
      member.domain.elements.length <= maxRadio
    );
  };

  const isDropdown = () => {
    var guiType = member.properties.guitype;
    return (
      !member.properties.ph_image_field &&
      (guiType == GuiTypes.DropDown || guiType == GuiTypes.Radio) &&
      member.domain.elements.length > maxRadio
    );
  };

  const isText = () => {
    return member.properties.guitype == GuiTypes.Text;
  };

  const isReadOnly = () => {
    return (
      !member.properties.ph_image_field &&
      member.properties.guitype == GuiTypes.ReadOnly
    );
  };

  const isReadOnlyImage = () => {
    return (
      member.properties.ph_image_field == 'yes' &&
      member.properties.guitype == GuiTypes.ReadOnly
    );
  };

  const isImageCheckBox = () => {
    return (
      member.properties.guitype == GuiTypes.DropDown &&
      member.properties.ph_image_field == 'yes'
    );
  };

  const lockSelectionsforVE = () => {
    if (
      sessionDataItems?.landingPageUrl != null &&
      sessionDataItems.landingPageUrl != '' &&
      sessionDataItems.option == '97'
    ) {
      if (sessionDataItems.isCADViewfromVE || startData.isManifoldProduct)
        return true;
      else {
        var veCommits = sessionDataItems.commits;
        if (veCommits.filter(x => x.key == member.name).length > 0) return true;
      }
    }
    return false;
  };

  const hasTooltip = () => {
    if (!member.properties.tc_field_view_text) return false;
    var toolTip = member.properties.tc_field_view_text;
    return toolTip != null && toolTip.length > 0;
  };

  const toolTip = () => {
    return member.properties.tc_field_view_text;
  };

  const commit = (member, stepName, e) => {
    handleOnChange(
      member?.name,
      startData.configState,
      'commit',
      e.target.value,
      '',
      member,
      stepName
    );
  };

  const unCommit = (member, stepName) => {
    handleOnChange(
      member?.name,
      startData.configState,
      'reset',
      member?.value,
      '',
      member,
      stepName
    );
  };
  return (
    <>
      {!isHidden(member) && (
        <>
          {showHeader() && (
            <h3 className="option-category">{member.description}</h3>
          )}
          {!isGroup() && (
            <div key={member.name} className="options">
              <Accordion expanded={open}>
                <AccordionSummary className="option-header">
                  <div
                    className="option-header-title"
                    onClick={() => setOpen(!open)}
                  >
                    {open ? <RemoveIcon /> : <AddIcon />}{' '}
                    <span> {member.description}</span>
                  </div>
                  {!lockSelectionsforVE() && (
                    <div className="option-status-wrapper align-right">
                      {hasTooltip() && (
                        <CustomTooltip title={toolTip()} placement="top">
                          <InfoIcon className="info-icon" />
                        </CustomTooltip>
                      )}
                      {!member.alwaysCommitted &&
                        member.committed &&
                        !isReadOnly() && (
                          <CustomTooltip
                            title={lang?.RESET_TO_DEFAULT}
                            placement="top"
                          >
                            <ReplayIcon
                              className="replay-icon-selected"
                              onClick={() => unCommit(member, stepName)}
                            />
                          </CustomTooltip>
                        )}
                      {member.alwaysCommitted && !isReadOnly(member) && (
                        <ReplayIcon className="replay-icon-selected" />
                      )}
                      {!member.alwaysCommitted &&
                        !member.committed &&
                        !isReadOnly(member) && (
                          <ReplayIcon className="replay-icon" />
                        )}
                    </div>
                  )}
                </AccordionSummary>
                <AccordionDetails>
                  {isReadOnly() && (
                    <div className="accordian-content">
                      <Typography>{member.valueDescription}</Typography>
                    </div>
                  )}

                  {isDropdown() && (
                    <div className="custom-dropdown-padding">
                      <DropdownCustom
                        member={member}
                        onChange={e => {
                          commit(member, stepName, e);
                        }}
                        isVE={lockSelectionsforVE()}
                      />
                    </div>
                  )}

                  {isText() && (
                    <TextOptionComponent
                      member={member}
                      isDisabled={lockSelectionsforVE()}
                      startData={startData}
                      onChange={e => {
                        commit(member, stepName, e);
                      }}
                    />
                  )}

                  {isRadioGroup() && (
                    <div className="accordian-content">
                      <RadioGroupCustom
                        member={member}
                        isVE={lockSelectionsforVE()}
                        onChange={e => {
                          commit(member, stepName, e);
                        }}
                      />
                    </div>
                  )}

                  {isReadOnlyImage() && (
                    <div className="accordian-content">
                      <ImageReadOnly member={member} imageUrls={imageUrls} />
                    </div>
                  )}

                  {isImageCheckBox() && (
                    <div className="accordian-content">
                      <ImageCheckBoxCustom
                        member={member}
                        isVE={lockSelectionsforVE()}
                        onChange={e => {
                          commit(member, stepName, e);
                        }}
                        startData={startData}
                        imageUrls={imageUrls}
                      />
                    </div>
                  )}
                </AccordionDetails>
              </Accordion>
            </div>
          )}
          {children()?.map(child => {
            return (
              <div key={member.name + '_' + child.name}>
                <MemberComponent
                  member={child}
                  sessionDataItems={sessionDataItems}
                  startData={startData}
                  handleOnChange={handleOnChange}
                  stepName={stepName}
                  lang={lang}
                  imageUrls={imageUrls}
                />
              </div>
            );
          })}
        </>
      )}
    </>
  );
}
export default MemberComponent;
